import CheckboxComponent from "@/components/Checkbox";
import { useAppDispatch } from "@/lib/redux/hooks";
import {
  ProductFilter,
  ProductFilterOption,
  updateProductFilterOption,
} from "@/lib/redux/productFilters/productFiltersSlice";
import { productFilterOptionSelectors } from "@/lib/redux/store";
import { useCallback } from "react";
import DropdownComponent from "./Dropdown";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Checkbox = CheckboxComponent as any;
const Dropdown = DropdownComponent as any;

type Props = {
  filter: ProductFilter;
  isOpen: boolean;
  handleOpen: () => void;
  handleClose: () => void;
};

const Selector: React.FC<Props> = (props) => {
  const { filter, isOpen, handleOpen, handleClose } = props;

  const dispatch = useAppDispatch();

  const handleChange = useCallback(
    (option: ProductFilterOption) => {
      dispatch(
        updateProductFilterOption({
          filterId: filter.id,
          optionId: option.value,
          changes: {
            // Toggle selected option
            selected: !option.selected,
          },
        })
      );
    },
    [dispatch, filter.id]
  );

  if (!filter) return null;
  const options = productFilterOptionSelectors.selectAll(filter);

  return (
    <Dropdown
      key={filter.id}
      handleOpen={handleOpen}
      handleClose={handleClose}
      isOpen={isOpen}
      label={filter.title}
    >
      {options.map((option) => (
        <Checkbox
          key={option.value}
          value={option.value}
          checked={option.selected}
          disabled={option.count === 0}
          onChange={() => handleChange(option)}
        >
          {option.value}{" "}
          {typeof option.count === "number" && "(" + option.count + ")"}
        </Checkbox>
      ))}
    </Dropdown>
  );
};

export default Selector;
